import React, { useEffect, useState } from 'react'
import { Nav, Form } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import Dropdown from 'react-bootstrap/Dropdown';
import DataTable from 'react-data-table-component';
import { BsThreeDots } from 'react-icons/bs';
import { getPaymentListing, updatePaymentStatus } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import viewIcon from "../../assets/svg/view.svg";
import { useNavigate } from 'react-router-dom';
import { checkUserPermissions } from '../../helpers/permission';
import { IoSearchOutline } from 'react-icons/io5';
import toast from 'react-hot-toast';
import { IoIosCheckmarkCircle } from 'react-icons/io';


const queueDatatableCustomStyles = {
  headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '14px',
      padding: '16px 8px',
      backgroundColor: '#f9f9f9ff',
    },
  },
  cells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontSize: '12px',
      fontWeight: '500',
      padding: '12px',
      padding: '20px 8px',
    },
  },

};

const Payment = () => {

  const navigate = useNavigate()

  const [payment, setPayment] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [limitactive, setLimitActive] = useState(10);
  const [page, setPage] = useState(1);
  const [pageactive, setPageActive] = useState(1);
  const [update, setUpdate] = useState(false);
  const [initial, setInitial] = useState(false);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");


  const userType = JSON.parse(localStorage.getItem('user'))?.userType;

  console.log("User Type:", userType);

  const columns = [
    {
      name: "S. No.",
      selector: (row, index) => {
        if (filter === "all") {
          return page * limit - limit + (index + 1);
        } else if (filter === "recents") {
          return pageactive * limitactive - limitactive + (index + 1);
        } else {
          return page * limit - limit + (index + 1);
        }
      },
      width: "90px",
      center: true,
    },
    {
      id: 'orderId',
      name: 'Order Id',
      selector: (row) => row?.orderId,
      cell: (row) => (
        <Tooltip title={row?.orderId} disableInteractive placement='top'>
          <div
            className="related-order-box"
            style={{
              backgroundColor: 'rgba(70, 70, 70, 0.1)' // 50% transparent
              ,
              color: 'black',
              padding: '4px 8px',
              borderRadius: '4px',
              fontWeight: '500',
              cursor: 'pointer',
              minWidth: '80px',
              textAlign: 'center',
              margin: '2px'
            }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/orderdetails/${row.orderId}`);
            }}
          >
            ODR-00000{row?.orderId}
          </div>
        </Tooltip>

      ),

      grow: 0.5,
      minWidth: '150px',
      center: true, // Added
    },
    {
      id: 'transactionId',
      name: 'Transaction Id',
      selector: (row) => row?.transactionId,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.transactionId} disableInteractive placement='top'>
            <div className='text-truncate'>{row?.transactionId}</div>
          </Tooltip>
        </div>
      ),
      minWidth: '200px',
      center: true,
    },
    {
      id: 'amount',
      name: 'Amount',
      selector: (row) => row?.amount,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.amount} disableInteractive placement='top'>
            <div className='text-truncate'>Rs.{row?.amount}</div>
          </Tooltip>
        </div>
      ),
      minWidth: '100px',
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row?.Order?.paymentStatus,
      cell: (row) => {
        const status = row?.Order?.paymentStatus;
        let bgColor = '';
        let textColor = 'white';

        // Set colors based on status
        if (status === "DONE") {
          bgColor = '#28a745'; // Green for completed
        } else {
          bgColor = '#dc7235ff'; // Orange for pending
        }

        return (
          <div className="text-capitalize">
            {status ? (
              <span
                style={{
                  backgroundColor: bgColor,
                  color: textColor,
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontWeight: '500'
                }}
              >
                {status === "DONE" ? "Completed" : "Pending"}
              </span>
            ) : (
              'N/A'
            )}
          </div>
        );
      },
      sortable: true,
      center: true,
      minWidth: '180px',
    },
    {
      id: 'paymentMode',
      name: 'Payment Mode',
      selector: (row) => row?.Order?.paymentMode,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.Order?.paymentMode} disableInteractive placement='top'>
            <div className='text-truncate'>{row?.Order?.paymentMode}</div>
          </Tooltip>
        </div>
      ),
      minWidth: '150px',
      center: true,
    },
    {
      id: 'createdAt',
      name: 'Date',
      selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
            <div className='text-truncate'>{moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')}</div>
          </Tooltip>
        </div>
      ),
      minWidth: '180px',
      center: true,
    },
    {
      id: 'refundId',
      name: 'Refund Id',
      selector: (row) => row?.refundId,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.refundId || 'N/A'} disableInteractive placement='top'>
            <div className='text-truncate'>{row?.refundId || 'N/A'}</div>
          </Tooltip>
        </div>
      ),
      minWidth: '200px',
      center: true,
    },
    {
      id: 'refundStatus',
      name: 'Refund Status',
      selector: (row) => row?.refundStatus,
      cell: (row) => {
        const status = row?.refundStatus;
        let bgColor = '';
        let textColor = 'white';
        let displayText = 'N/A';

        if (status === "processed") {
          bgColor = '#28a745'; // Green for processed
          displayText = "Processed";
        } else if (status === "pending") {
          bgColor = '#ffc107'; // Yellow for pending
          displayText = "Pending";
        } else if (status === "failed") {
          bgColor = '#dc3545'; // Red for failed
          displayText = "Failed";
        } else {
          bgColor = '#6c757d'; // Gray for no status
          displayText = "N/A";
        }

        return (
          <div className="text-capitalize">
            <span
              style={{
                backgroundColor: bgColor,
                color: textColor,
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: '500'
              }}
            >
              {displayText}
            </span>
          </div>
        );
      },
      minWidth: '150px',
      center: true,
    },
    {
      id: 'refundInitiatedAt',
      name: 'Refund Date',
      selector: (row) => row?.refundInitiatedAt ? moment(row?.refundInitiatedAt).format('DD/MM/YYYY, hh:mm a') : 'N/A',
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.refundInitiatedAt ? moment(row?.refundInitiatedAt).format('DD/MM/YYYY, hh:mm a') : 'N/A'} disableInteractive placement='top'>
            <div className='text-truncate'>
              {row?.refundInitiatedAt ? moment(row?.refundInitiatedAt).format('DD/MM/YYYY, hh:mm a') : 'N/A'}
            </div>
          </Tooltip>
        </div>
      ),
      minWidth: '180px',
      center: true,
    },

    ...(userType === "ADMIN"
      ? [
        {
          name: "Mark as Completed",
          cell: (row) => (
            <div className="d-flex justify-content-center">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-row gap-3" role="button">
                  {checkUserPermissions("manage_payments") && (
                    <>
                      {row?.Order?.paymentStatus === "PENDING" && (
                        <Tooltip title="Mark as Completed" disableInteractive placement="top">
                          <div
                            className="request_btn"
                            style={{
                              padding: "1rem 1rem",
                              fontSize: "0.75rem",
                              lineHeight: "1.5",
                              backgroundColor: '#28a745', // Green to match completed status
                              borderRadius: '4px',
                              cursor: 'pointer'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleUpdateStatus(row?.Order?.id);
                            }}
                          >
                            <IoIosCheckmarkCircle size={20} style={{ color: "#FFFFFF" }} />
                          </div>
                        </Tooltip>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ),
          minWidth: '200px',
          ignoreRowClick: true,
          allowOverflow: true,
          button: true,
          center: true,
        },
      ]
      : []),
  ];

  // const conditionalRowStyles = [
  //   {
  //     when: row => row.refundId !== null,
  //     style: {
  //       backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
  //       '&:hover': {
  //         backgroundColor: 'rgba(238, 145, 155, 0.1)' // Slightly darker on hover
  //       }
  //     },
  //   },
  // ];


  const handleUpdateStatus = async (orderId) => {
    try {
      setLoading(true);
      // Call your API to update the payment status
      updatePaymentStatus({ orderId: orderId })((response) => {
        if (response.statusCode === 200) {
          setUpdate((prev) => !prev);
          toast.success("Payment status updated successfully");
        } else {
          toast.error("Failed to update payment status");
        }
        setLoading(false);
      });
    } catch (error) {
      console.error("Error updating payment status:", error);
      toast.error("An error occurred while updating payment status");
      setLoading(false);
    }
  };

  const fetchPaymentData = async (filter) => {
    const params = {
      page: page,
      pageSize: limit,
    };

    if (search && search.trim() !== "") {
      params.search = search;
    }

    if (filter === 'recents') {
      params.status = 'RECENTS';
    }

    getPaymentListing(params)((response) => {
      if (response?.statusCode === 200) {
        setPayment(response?.data?.orders);
        setTotalRows(response?.data?.totalItems);
        setLoading(false);
      } else {
        setPayment([]);
        setLoading(false);
      }
    });
  };

  const handleFilterChange = (filter) => {
    console.log(filter);
    setPage(1);
    setFilter(filter);
  };

  const handlePerRowsActiveChange = (newPerPage, page) => {
    setLimitActive(newPerPage);
    setPageActive(1);
    setUpdate(!update);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setPage(1);
    setUpdate(!update);
  };

  const handlePageChange = (page) => {
    setPage(page);
    setUpdate(!update);
  };

  useEffect(() => {
    setLoading(true);
    fetchPaymentData(filter);
  }, [update, filter]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) setUpdate(!update);
      else setInitial(true);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);



  return (
    <div>
      <div className="page-header-sticky d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="d-flex align-items-center">
          <h3 className="mb-0 fw-bold">Payments</h3>
        </div>

        <Form.Control
          type="text"
          placeholder="Search payments using Order Id..."
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "360px",
            maxWidth: "100%",
            minHeight: "40px",
            borderRadius: "8px",
            fontSize: "13px",
            background: "#fff",
            border: "1px solid #d1d5db",
          }}
        />
      </div>

      <div className='col-12'>
        {filter == "all" && (
          <Box className="products-and-options" sx={{ mt: 1 }}>
            <Paper square className='shadow-none border border-blue-grey-200'>
              <div>
                <DataTable
                  columns={columns}
                  // conditionalRowStyles={conditionalRowStyles}
                  data={payment}
                  progressPending={loading}
                  progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationRowsPerPageOptions={[10, 50, 100, 150]}
                  paginationPerPage={limit}
                  onRowClicked={(row) => navigate('/paymentdetails', { state: { paymentDetails: row } })}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  currentPage={page}
                  customStyles={queueDatatableCustomStyles}
                />
              </div>
            </Paper>
          </Box>
        )}
        {filter == "recents" && (
          <Box className="products-and-options" sx={{ mt: 1 }}>
            <Paper square>
              <div>
                <DataTable
                  columns={columns}
                  data={payment}
                  progressPending={loading}
                  progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={limit}
                  onChangeRowsPerPage={handlePerRowsChange}
                  paginationRowsPerPageOptions={[10, 50, 100, 150]}
                  onChangePage={handlePageChange}
                  currentPage={page}
                  customStyles={queueDatatableCustomStyles}
                />
              </div>
            </Paper>
          </Box>
        )}
      </div>
    </div>
  )
}

export default Payment
